import { Box, Container, Paper } from '@mui/material'
import { URL_HOME } from 'helpers/config'
import images from 'assets/images'

type Props = {
  children: React.ReactNode
}

const AuthTemplate = (props: Props) => {
  return (
    <Container sx={{ py: '16px' }}>
      <Box>
        <Box display="flex" justifyContent="center" p="24px">
          <a href={URL_HOME}>
            <img alt="logo" style={{ width: 'min(100%, 400px)' }} src={images.LOGO_NN} />
          </a>
        </Box>

        <Paper variant="outlined" sx={{ p: '24px', textAlign: 'center' }}>
          {props.children}
        </Paper>
      </Box>
    </Container>
  )
}

export default AuthTemplate
